export function emptyRows(page: number, rowsPerPage: number, arrayLength: number) {
  if (!arrayLength) {
    return 0;
  }
  return Math.max(0, page * rowsPerPage - arrayLength);
}
